import version from '../../package.json';

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }

        var aux = JSON.parse(serializedState);
        delete aux.form;
        delete aux.window_tools;

        if (version.version === aux.version && process.env.NODE_ENV === 'development') {
            console.log('Cargado localStorage version: ' + aux.version);
            return aux;
        } else {
            console.log(
                'No valido localStorage version: ' +
                    aux.version +
                    ' entorno: ' +
                    process.env.NODE_ENV,
            );
            return undefined;
        }
    } catch (error) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        var persistedState = JSON.stringify(state);
        localStorage.setItem('state', persistedState);
    } catch (error) {
        //ignore error
    }
};



// WEBPACK FOOTER //
// ./src/store/persisted.store.js